/**
 * en-GB messages added by Phase 4 task S47 (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s47EnGB = {
    'nav.integrations': 'Integrations',
    'integrations.error.url_refused': 'This address cannot be used. Slack needs a hooks.slack.com incoming webhook address; Teams needs a Workflows webhook address.',
    'integrations.error.connection_unavailable': 'The Slack or Teams connection for this message no longer exists.',
    'integrations.error.connection_disabled': 'The Slack or Teams connection for this message is switched off.',
    'integrations.error.send_failed': 'The message could not be sent.',
    'integrations.error.http_4xx': 'Slack or Teams refused the message. Check the connection address.',
    'integrations.error.http_429': 'Slack or Teams asked us to slow down. We will try again.',
    'integrations.error.http_5xx': 'Slack or Teams had a problem. We will try again.',
    'integrations.error.timeout': 'Slack or Teams did not answer in time.',
    'integrations.error.connection_failed': 'We could not reach Slack or Teams.',
    'integrations.error.dns_failed': 'We could not find the Slack or Teams address.',
    'integrations.error.blocked_address': 'This address points somewhere CloudSign is not allowed to send to.',
    'integrations.error.invalid_url': 'This address is not valid.',
    'integrations.error.scheme_not_allowed': 'The address must start with https://.',
    'integrations.error.port_not_allowed': 'The address must not contain a port or sign-in details.',
    'integrations.error.body_too_large': 'The message was too large to send.',
    'integrations.error.invalid_headers': 'The message could not be sent.',
    'email.integrations.connection_disabled.subject': '{connection} has been switched off',
    'email.integrations.connection_disabled.body': '{tenant}: CloudSign could not deliver messages to "{connection}" several times in a row, so it has been switched off. Check the address on the Integrations page, then switch it back on.',
    'email.integrations.connection_disabled.button': 'Open the Integrations page',
};
//# sourceMappingURL=s47.js.map